<template>
    <header class="section-header section-header--secondary" :class="settings.resultsType === 'lender' ? 'section-header--flipped' : ''">
        <h3 class="section-header__heading">{{settings.headerText}}</h3>
        <hr class="section-header__hr" aria-hidden="true">
    </header>
</template>

<script>
    export default {
        computed: {
            settings: function () {
                return this.$store.state.settings;
            }
        }
    }
</script>